import React, { useReducer } from "react";
import Context from "./context.js";

const defaultState = {
    cars: [],
    search: { make: "", year: "", km: "", click: false, btn_text: "חפש עכשיו" },
    selected: {
        car_id: "", car_make: "", year: "", km: "", next_test: "",
        hand: "", engine: "", gear: "", color: "", owner: "",
        car_type: "", price: "", p_image: "", more_details: "", tag: "", recommended: false, p_list: "", tiktok_url: "", isSale: "no"
    },
    images: [{ url: "", primary: false }, { url: "", primary: false }, { url: "", primary: false }, { url: "", primary: false }, { url: "", primary: false }, { url: "", primary: false }],
    tabSelectedAdmin: "עריכת רכבים",
    api_url: window.location.hostname === "localhost"
        ? "http://localhost:5000/api"
        : "/api",
    tabSelectedUser: "חיפוש רכבים",
    delete_car: "",
    banner_images: [],
    reviews: [],
    favCars: false,
    arrFavCars: []

};

const dataReducer = (state, values) => {
    switch (values.name) {
        case "setAllCars":
            return { ...state, cars: values.data };
        case "setSearch":
            return { ...state, search: values.data };
        case "setSelected":
            return { ...state, selected: values.data };
        case "setTabSelectedAdmin":
            return { ...state, tabSelectedAdmin: values.data };
        case "setTabSelectedUser":
            return { ...state, tabSelectedUser: values.data };
        case "setDeleteCar":
            return { ...state, delete_car: values.data };
        case "setBanner":
            return { ...state, banner_images: values.data };
        case "setReviews":
            return { ...state, reviews: values.data };
        case "setFavCars":
            return { ...state, favCars: values.data };
        case "setArrFavCars":
            return { ...state, arrFavCars: values.data };
        default:
            return state;
    }
};

const Provider = (props) => {
    const [data, dispatchData] = useReducer(dataReducer, defaultState);

    const setArrFavCars = (arr) => {
        dispatchData({
            name: "setArrFavCars",
            data: arr
        });
    };

    const setFavCars = (favCarsValue) => {
        dispatchData({
            name: "setFavCars",
            data: favCarsValue
        });
    };

    const setReviews = (review) => {
        dispatchData({
            name: "setReviews",
            data: review
        });
    };


    const setBanner = (images) => {
        dispatchData({
            name: "setBanner",
            data: images
        });
    };

    const setDeleteCar = (d) => {
        dispatchData({
            name: "setDeleteCar",
            data: d
        });
    };

    const setTabSelectedUser = (s) => {
        dispatchData({
            name: "setTabSelectedUser",
            data: s
        });
    };

    const setTabSelectedAdmin = (s) => {
        dispatchData({
            name: "setTabSelectedAdmin",
            data: s
        });
    };

    const setSearch = (s) => {
        dispatchData({
            name: "setSearch",
            data: s
        });
    };

    const setSelected = (s) => {
        dispatchData({
            name: "setSelected",
            data: s
        });
    };




    const setAllCars = (cars) => {
        dispatchData({
            name: "setAllCars",
            data: cars
        });
    };



    const stageContext = {
        setAllCars: setAllCars,
        setSearch: setSearch,
        setSelected: setSelected,
        setTabSelectedAdmin: setTabSelectedAdmin,
        setTabSelectedUser: setTabSelectedUser,
        setDeleteCar: setDeleteCar,
        setBanner: setBanner,
        setReviews: setReviews,
        setFavCars: setFavCars,
        setArrFavCars: setArrFavCars,
        getArrFavCars: data.arrFavCars,
        getFavCars: data.favCars,
        getSearch: data.search,
        getAllCars: data.cars,
        getSelected: data.selected,
        images: data.images,
        tagSelectedAdmin: data.tabSelectedAdmin,
        api_url: data.api_url,
        tabSelectedUser: data.tabSelectedUser,
        delete_car: data.delete_car,
        getBanner: data.banner_images,
        getReviews: data.reviews

    }

    return (
        <Context.Provider value={stageContext}>{props.children}</Context.Provider>
    );

}
export default Provider;